
const Css = {
  timeSlider(width, left) {
    return {
      width: width + "px",
      left: left + "px",
      height: "12px",
      // border: "1px solid #121212",
      backgroundColor: "#666666",
      float: "left",
      position: "relative",
      borderRadius: "4px",
      cursor: "pointer",
    }
  },
  sliderBox(width){
    return {
      position: "relative",
      width: width + "px",
      height: "12px",
      border: "none",
      backgroundColor: "#2e2e2e",
      float: "left",
      borderTopLeftRadius: "6px",
      borderTopRightRadius: "6px",
      transition: "all 0.05s linear", //渐变动画防止视觉卡顿
    }
  }
}

export default Css;